/**Dirección simple para reclamo */
export class ComplaintSimpleAddress {
    /**Descripción */
    public description: string;
    /**Referencia */
    public reference: string;
    /**Código de distrito */
    public districtCode: string;
    /**Código de provincia */
    public provinceCode: string;
    /**Código de departamento */
    public departmentCode: string;
}